import { MenuEntry } from '@src/menu-entry';

export default MenuEntry.create()
    .setRoute('user_token_list');
